import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: top;
  justify-content: center;
  width: 100%;
  font-size: 60px;
  box-sizing: border-box;
  color: blue;
  overflow: visible;
  @media (max-width: 980px) {
    width: 100%;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  @media (max-width: 980px) {
    padding: 10px 16px;
  }
`;
